import React, { useState, useEffect } from 'react';

const Devices = () => {
    // State for Devices
    const [devices, setDevices] = useState([]);

    // State for Add Device Modal
    const [showModal, setShowModal] = useState(false);
    const [newDeviceName, setNewDeviceName] = useState('');

    // --- NEW: State for Send Message Modal ---
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [selectedDeviceId, setSelectedDeviceId] = useState('');
    const [targetNumber, setTargetNumber] = useState('');

    // Fetch live data from your Express Backend
    const fetchDevices = async () => {
        try {
            const response = await fetch('https://whatsapp.hlgroups.in/api/devices');
            const data = await response.json();
            setDevices(data);
        } catch (error) {
            console.error("Error fetching from backend:", error);
        }
    };

    // Auto-refresh the page every 2 seconds
    useEffect(() => {
        fetchDevices();
        const interval = setInterval(() => {
            fetchDevices();
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    // Add a new device
    const handleAddDevice = async () => {
        if (!newDeviceName.trim()) return alert("Please enter a device name");
        try {
            const response = await fetch('https://whatsapp.hlgroups.in/api/devices/add', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ deviceId: newDeviceName })
            });
            const result = await response.json();
            if (result.success) {
                setNewDeviceName('');
                setShowModal(false);
                fetchDevices();
            } else {
                alert(result.error);
            }
        } catch (error) {
            alert("Could not connect to backend server.");
        }
    };
    const handleSendMessage = async () => {
        if (!targetNumber.trim()) return alert("Please enter a phone number!");

        // Clean the number
        let cleanedNumber = targetNumber.replace(/\D/g, '');

        // Ensure it has country code
        if (!cleanedNumber.startsWith('91') && !cleanedNumber.startsWith('1') && !cleanedNumber.startsWith('44')) {
            // Add default country code (change based on your needs)
            cleanedNumber = '91' + cleanedNumber;
        }

        try {
            const response = await fetch('https://whatsapp.hlgroups.in/api/send', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'my_secret_key_123'
                },
                body: JSON.stringify({
                    deviceId: selectedDeviceId,
                    number: cleanedNumber,
                    message: `Hello from ${selectedDeviceId}! This is a demo message sent from your React Dashboard. 🚀`
                })
            });

            const result = await response.json();

            if (result.success) {
                alert("✅ Message Sent Successfully!");
                setShowMessageModal(false);
                setTargetNumber('');
            } else {
                alert("❌ Failed to send: " + (result.error || result.details || 'Unknown error'));
            }
        } catch (error) {
            console.error("Failed to send message", error);
            alert("Could not connect to backend to send message.");
        }
    };

    // Open the Message Modal for a specific device
    const openMessageModal = (deviceId) => {
        setSelectedDeviceId(deviceId);
        setShowMessageModal(true);
    };

    const hideDeviceFromUI = (id) => {
        setDevices(devices.filter(device => device.id !== id));
    };

    return (
        <div className="devices-page">
            <style>{`
        .device-card {
          background: white;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.05);
          padding: 20px;
          text-align: center;
          height: 100%;
          border-top: 4px solid #25D366;
        }
        .qr-placeholder {
          width: 200px;
          height: 200px;
          margin: 0 auto 15px auto;
          border: 1px solid #eee;
          padding: 10px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .status-badge { font-size: 14px; padding: 5px 10px; border-radius: 20px; }
        .status-initializing { background-color: #e2e3e5; color: #383d41; }
        .status-waiting { background-color: #fff3cd; color: #856404; }
        .status-connected { background-color: #d4edda; color: #155724; }
        
        .custom-modal-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex; align-items: center; justify-content: center;
          z-index: 1000;
        }
        .custom-modal {
          background: white; padding: 25px; border-radius: 8px; width: 400px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.2);
        }
      `}</style>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Connected Devices</h2>
                <button className="btn btn-success" onClick={() => setShowModal(true)}>
                    + Add Device
                </button>
            </div>

            <div className="row">
                {devices.length === 0 ? (
                    <div className="col-12 text-center text-muted mt-5">
                        <h4>No devices connected. Click "Add Device" to start.</h4>
                    </div>
                ) : (
                    devices.map(device => (
                        <div className="col-md-4 mb-4" key={device.id}>
                            <div className="device-card">
                                <h4 className="mb-3">{device.name}</h4>

                                {device.status === 'INITIALIZING' && (
                                    <>
                                        <div className="qr-placeholder"><div className="spinner-border text-success"></div></div>
                                        <span className="status-badge status-initializing mb-3 d-inline-block">Generating QR...</span>
                                    </>
                                )}

                                {device.status === 'WAITING_FOR_QR' && device.qr && (
                                    <>
                                        <div className="qr-placeholder">
                                            <img src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(device.qr)}`} alt="Scan me" style={{ width: '100%' }} />
                                        </div>
                                        <span className="status-badge status-waiting mb-3 d-inline-block">Waiting for Scan...</span>
                                    </>
                                )}

                                {device.status === 'CONNECTED' && (
                                    <>
                                        <div className="mb-3" style={{ height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <h1 style={{ fontSize: '70px', color: '#25D366', margin: 0 }}>✅</h1>
                                        </div>
                                        <span className="status-badge status-connected mb-3 d-inline-block">Connected</span>

                                        {/* NEW: Send Demo Message Button */}
                                        <button
                                            className="btn btn-primary w-100 mb-2"
                                            onClick={() => openMessageModal(device.id)}>
                                            ✉️ Send Demo Message
                                        </button>
                                    </>
                                )}

                                <button className="btn btn-sm btn-outline-danger w-100" onClick={() => hideDeviceFromUI(device.id)}>
                                    Hide from Dashboard
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {/* Add Device Modal */}
            {showModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">
                        <h4 className="mb-3">Add New Device</h4>
                        <div className="form-group mb-3">
                            <label>Device Name</label>
                            <input type="text" className="form-control mt-2" placeholder="Enter name..." value={newDeviceName} onChange={(e) => setNewDeviceName(e.target.value)} autoFocus />
                        </div>
                        <div className="d-flex justify-content-end">
                            <button className="btn btn-secondary me-2" onClick={() => setShowModal(false)}>Cancel</button>
                            <button className="btn btn-success" onClick={handleAddDevice}>Start Connection</button>
                        </div>
                    </div>
                </div>
            )}

            {/* NEW: Send Message Modal */}
            {showMessageModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">
                        <h4 className="mb-3">Send Demo Message</h4>
                        <p className="text-muted small">Sending from: <strong>{selectedDeviceId}</strong></p>

                        <div className="form-group mb-3">
                            <label>Target Phone Number (with Country Code)</label>
                            <input
                                type="text"
                                className="form-control mt-2"
                                placeholder="e.g. 919876543210"
                                value={targetNumber}
                                onChange={(e) => setTargetNumber(e.target.value)}
                                autoFocus
                            />
                            <small className="text-muted">Do not use + or spaces.</small>
                        </div>

                        <div className="d-flex justify-content-end mt-4">
                            <button className="btn btn-secondary me-2" onClick={() => setShowMessageModal(false)}>Cancel</button>
                            <button className="btn btn-primary" onClick={handleSendMessage}>Send Message</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Devices;